import { render, staticRenderFns } from "./ProductsActionModal.html?vue&type=template&id=d9059f8e&scoped=true&"
import script from "./ProductsActionModal.vue?vue&type=script&lang=js&"
export * from "./ProductsActionModal.vue?vue&type=script&lang=js&"
import style0 from "./ProductsActionModal.scss?vue&type=style&index=0&id=d9059f8e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d9059f8e",
  null
  
)

export default component.exports